import styled from 'styled-components';

export const EmptyContainer = styled.div`
  height: ${props => props.height || 50}px;
`;

export const ErrorsContainer = styled.div`
  padding: 20px 0 20px 0;
`;
